import {
  Injectable,
  Component,
  ElementRef,
  ComponentFactoryResolver,
  ViewContainerRef
} from '@angular/core';
import { SxMarcaDesigner } from '../components/designers/layout/deprecated/marca.designer.component';
import { SxEmailDesigner } from '../components/designers/layout/deprecated/email.designer.component';
import { SxSeparatorDesigner } from '../components/designers/layout/text-editors/separator.designer.component';
import { SxTitleDesigner } from '../components/designers/layout/text-editors/title.designer.component';
import { SxSimpleContainerDesigner } from '../components/designers/layout/containers/simple-container.designer.component';
import { SxGroupDesigner } from '../components/designers/layout/containers/group.designer.component';
import { SxPanelDesigner } from '../components/designers/layout/containers/panel.designer.component';
import { SxModalDesigner } from '../components/designers/layout/containers/modal-designer.component';
import { SxColumnsDesigner } from '../components/designers/layout/containers/columns-designer-component';
import { BaseDesignerComponent } from '../components/designers/base/base-designer-component';
import { SxCustomControl } from '../components/designers/custom/custom-control-designer.component';
import { IDesignerFactoryService } from './designer-factory-interface';
import { SxParagraphDesigner } from '../components/designers/layout/text-editors/paragraph-designer-component';
import { SxImageDesigner } from '../components/designers/layout/files-manager/imageDesigner.component';
import { UnknownDesignerComponent } from '../components/designers/layout/deprecated/unknowDesigner.component';
import { SxAttributeList } from '../components/designers/layout/flow-actions/attributeListDesigner.component';
import { SxFileExportGroupDesigner } from '../components/designers/layout/files-manager/fileExportGroup.designer.component';
import { SxFileSelectorDesigner } from '../components/designers/layout/files-manager/fileSelectorDesigner.component';
import { SxFileImportDesigner } from '../components/designers/layout/files-manager/fileImport.designer.component';
import { SxViewEngine } from '../components/designers/view-engine/viewEngine.component';
import { SxQuotationResultDesigner } from '../components/designers/layout/flow-actions/quotationResultDesigner.component';
import { SxAsyncQuotationResultDesigner } from '../components/designers/layout/flow-actions/quotationResultAsyncDesigner.component';
import { SxSyncCandidatesDesigner } from '../components/designers/layout/flow-actions/syncCandidatesDesigner.component';
import { SxPaymentGatewayDesigner } from '../components/designers/layout/flow-actions/paymentGatewayDesigner.component';
import { SxActionButtonComponent } from '../components/designers/layout/flow-actions/actionbuttonDesigner.component';
import { SxDynamicAttributeContainerDesigner } from '../components/designers/layout/containers/dynamicAttributeContainer.designer.component';
import { SxRedirecPGDesigner } from '../components/designers/layout/flow-actions/redirectPaymentGateway.component';
import { SxGroupCollapsibleDesigner } from '../components/designers/layout/containers/group-collapsible.designer.component';


@Injectable()
export class DesignerFactoryService implements IDesignerFactoryService {
  private mappings = {
    SxMarca: SxMarcaDesigner,
    SxViewEngine: SxViewEngine,
    SxEmail: SxEmailDesigner,
    SxSeparator: SxSeparatorDesigner,
    SxTitle: SxTitleDesigner,
    SxGroup: SxGroupDesigner,
    SxGroupCollapsible: SxGroupCollapsibleDesigner,
    SxDynamicAttrContainer: SxDynamicAttributeContainerDesigner,
    SxPanel: SxPanelDesigner,
    SxModal: SxModalDesigner,
    SxColumns: SxColumnsDesigner,
    SxSimpleContainer: SxSimpleContainerDesigner,
    SxCustomControl: SxCustomControl,
    SxParagraph: SxParagraphDesigner,
    SxImage: SxImageDesigner,
    SxQuotationResult: SxQuotationResultDesigner,
    SxAsyncQuoteResult: SxAsyncQuotationResultDesigner,
    SxSyncCandidates: SxSyncCandidatesDesigner,
    SxPaymentGateway: SxPaymentGatewayDesigner,
    SxActionButton: SxActionButtonComponent,
    SxAttributeList: SxAttributeList,
    SxFileExportGroup : SxFileExportGroupDesigner,
    SxFileSelector : SxFileSelectorDesigner,
    SxFileImport : SxFileImportDesigner,
    SxRedirectPG : SxRedirecPGDesigner
  };

  constructor(private resolver: ComponentFactoryResolver) {}

  getComponent(typeName: string): any {
    if (!typeName) {
      return UnknownDesignerComponent;
    }

    const type = this.mappings[typeName];
    return type || UnknownDesignerComponent;
  }

  create(typeName: string, container: ViewContainerRef): any {
    if (!typeName) {
      return null;
    }

    const type = this.getComponent(typeName);
    const factory = this.resolver.resolveComponentFactory(type);
    const componentRef = container.createComponent(factory);

    return componentRef;
  }

  clear(container: ViewContainerRef) {
    container.clear();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/services/designer-factory-service.ts